<template>
  <div>
    <a-modal v-model="visible" title="每日收益" @ok="handleOk" :width="1000" :footer="null">
      <search-robot @changeRobotId="onChangeRobotId"></search-robot>

      <div style="display: flex; justify-content: center;">
        <a-card style="width: 200px; height: 100px">
          <div style="position: absolute; top: 5px">今日-GMV</div>
          <div style="font-size: 28px; color: black; margin-top: 10px">
            <span>￥</span>
            <span>5000</span>
          </div>
        </a-card>
        <a-card style="width: 200px; height: 100px; margin-left: 10px">
          <div style="position: absolute; top: 5px">今日-总订单数</div>
          <div style="font-size: 28px; color: black; margin-top: 10px">
            <span>￥</span>
            <span>5000</span>
          </div>
        </a-card>
        <a-card style="width: 200px; height: 100px; margin-left: 10px">
          <div style="position: absolute; top: 5px">今日-有效佣金</div>
          <div style="font-size: 28px; color: black; margin-top: 10px">
            <span>￥</span>
            <span>5000</span>
          </div>
        </a-card>
        <a-card style="width: 200px; height: 100px; margin-left: 10px">
          <div style="position: absolute; top: 5px">今日-有效订单数</div>
          <div style="font-size: 28px; color: black; margin-top: 10px">
            <span>￥</span>
            <span>5000</span>
          </div>
        </a-card>
      </div>
      <div style="display: flex; justify-content: center; margin-top: 10px; margin-bottom: 30px;">
        <a-card style="width: 200px; height: 100px">
          <div style="position: absolute; top: 5px">昨日-GMV</div>
          <div style="font-size: 28px; color: black; margin-top: 10px">
            <span>￥</span>
            <span>5000</span>
          </div>
        </a-card>
        <a-card style="width: 200px; height: 100px; margin-left: 10px">
          <div style="position: absolute; top: 5px">昨日-总订单数</div>
          <div style="font-size: 28px; color: black; margin-top: 10px">
            <span>￥</span>
            <span>5000</span>
          </div>
        </a-card>
        <a-card style="width: 200px; height: 100px; margin-left: 10px">
          <div style="position: absolute; top: 5px">昨日-有效佣金</div>
          <div style="font-size: 28px; color: black; margin-top: 10px">
            <span>￥</span>
            <span>5000</span>
          </div>
        </a-card>
        <a-card style="width: 200px; height: 100px; margin-left: 10px">
          <div style="position: absolute; top: 5px">昨日-有效订单数</div>
          <div style="font-size: 28px; color: black; margin-top: 10px">
            <span>￥</span>
            <span>5000</span>
          </div>
        </a-card>
      </div>
    </a-modal>
  </div>
</template>

<script>
import SearchRobot from '@/views/components/SearchRobot'

export default {
  components: {
    SearchRobot,
  },

  data() {
    return {
      visible: false,
      currentRobotId: '',
    }
  },

  methods: {
    onChangeRobotId(id) {
      this.currentRobotId = id
      console.log('点击搜索currentRobotId=', this.currentRobotId)
    },

    show() {
      this.visible = true
    },

    handleOk() {
      this.visible = false
    },
  },
}
</script>
